var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{staticClass:"cta-overlay",attrs:{"opacity":"0.50","color":"#000000","dark":false,"value":_vm.$ctaModal.display}},[_c('cta-form',{on:{"close":() => _vm.$ctaModal.hide()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }